<template>
  <div class="d-flex align-center justify-center">
    <v-card max-width="950" class="w-100 pa-10">
      <div class="send">
        <div>
          <label class="f14 font-weight-bold primary--text">{{
            localStorage.translations.pages.common.text.receiver
          }}</label>
          <div class="my-2 pb-4">
            <v-btn rounded small depressed style="text-transform: none" class="primary--text ml-2">
              reciever_email@mail.com
            </v-btn>
          </div>
          <label class="f14 font-weight-bold primary--text">{{
            localStorage.translations.pages.common.text.sender
          }}</label>
          <div class="my-2">
            <v-btn rounded small depressed style="text-transform: none" class="primary--text ml-2">
              sender_email@mail.com
            </v-btn>
          </div>
        </div>
        <div class="d-flex flex-column">
          <label class="f14 primary--text font-weight-medium customLineHeight">
            {{ localStorage.translations.pages.common.text['mail_title'] }}
          </label>
          <span class="f16"> {{ project_offer_email_title }} </span>
        </div>
        <BaseInput
          :label="localStorage.translations.pages.chat.all.message"
          v-model="allData.project_offer_email_text.value"
          type="textarea"
          :view-value="allData.project_offer_email_text.value"
          v-bind="presetBaseInput"
          @input="disable_email_text = false"
        >
          <template slot="append-outer">
            <v-btn
              color="primary"
              class="btn-pt"
              depressed
              :disabled="!navigationGuardianActive == true && disable_email_text == false
                ? !navigationGuardianActive && (disable_email_text = true)
                : disable_email_text"
              @click="prepareData(allData.project_offer_email_text)"
            >
              <BaseIcon width="20" height="20" icon="button-save" />
            </v-btn>
          </template>
        </BaseInput>
        <BaseInput
          :label="localStorage.translations.pages.common.buttons.sign"
          v-model="allData.project_offer_email_sign.value"
          type="textarea"
          :view-value="allData.project_offer_email_sign.value"
          v-bind="presetBaseInput"
          @input="disable_email_sign = false"
        >
          <template slot="append-outer">
            <v-btn
              color="primary"
              class="btn-pt"
              depressed
              :disabled="!navigationGuardianActive == true && disable_email_sign == false
                ? !navigationGuardianActive && (disable_email_sign = true)
                : disable_email_sign"
              @click="prepareData(allData.project_offer_email_sign)"
            >
              <BaseIcon width="20" height="20" icon="button-save" />
            </v-btn>
          </template>
        </BaseInput>
      </div>
    </v-card>
    <div class="fixedBtn">
      <BaseTooltip
        v-if="edit"
        :tooltip="localStorage.translations.pages.common['buttons']['sohranit']"
      >
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="prepareAllData(allData)"
          round
          icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
      <BaseTooltip
        v-else
        :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']"
      >
        <BaseButton @click="onEdit" round size="60" icon_only default_icon="button-edit" />
      </BaseTooltip>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'settingTemplateLetterPage',
  data: () => ({
    list: [],
    item: '',
    project_offer_email_title:  'OFFER NO. #AA000000A Company Oy Project name',
    allData: {
      project_offer_email_text: {
        name: 'project_offer_email_text',
        value: '',
        id: 8,
      },
      project_offer_email_sign: {
        name: 'project_offer_email_sign',
        value: '',
        id: 9,
      },
    },
    disable_email_text: true,
    disable_email_sign: true,
    fieldsLabels: [
      'project_offer_email_text',
      'project_offer_email_sign',
    ],
  }),
  computed: {
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    ...mapGetters(['inputRules']),
    ...mapGetters('commonContent', ['categoryContentData']),
    presetBaseInput() {
      return {
        view: !this.edit,
      }
    },
    edit() {
      return this.$route.name === 'SettingLetterEdit'
    },
  },
  created() {
    this.getTemplateContentData()
  },
  watch: {
    '$route.name'() {
      this.onCheckChange({ overwrite: true })
    },
    allData: {
      handler() {
        if (this.edit) this.onCheckChange({ overwrite: false })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    ...mapActions('commonContent', ['onGetCategoryContent', 'onChangeContentData']),
    async getTemplateContentData() {
      let data = {
        category: 'project_offer_email',
        contentable_type: '',
        contentable_id: '',
      }
      await this.onGetCategoryContent(data).then((res) => {
        let temp = res.data.data.map((i) => i.name)
        for (let i in this.fieldsLabels) {
          let index = temp.indexOf(this.fieldsLabels[i])
          this.allData[this.fieldsLabels[i]].value = res.data.data[index].value
        }
      })
    },
    prepareData(data) {
      let result = {
        content: [
          {
            category: 'project_offer_email',
            name: data.name,
            value: data.value,
          },
        ],
      }
      this.updateData(result)
    },
    prepareAllData(data) {
      let result = {
        content: [
          {
            category: 'project_offer_email',
            name: Object.values(data)[0].name,
            value: Object.values(data)[0].value,
          },
          {
            category: 'project_offer_email',
            name: Object.values(data)[1].name,
            value: Object.values(data)[1].value,
          },
        ],
      }
      let multi_field = true
      this.updateData(result, multi_field)
    },
    async updateData(data, multi_field) {
      this.fieldsDisabled()
      await this.onChangeContentData(data)
       .then(() => {
         this.getTemplateContentData()
         this.onSave()
         if (multi_field){
           this.onEdit()
           this.$store.dispatch(
            'popup/onMessage',
            {
              message:
               this.localStorage.translations.pages.common.notifications[
                'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
           )
           this.dialog = false
         }
       })
       .catch((err) => {
         console.log(err)
         this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['oshibka'],
            IsError: true,
          },
          { root: true },
         )
       })
    },
    fieldsDisabled() {
      this.disable_email_text = true
      this.disable_email_sign = true
    },
    onEdit() {
      this.$router.push({ name: this.edit ? 'SettingLetter' : 'SettingLetterEdit' })
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { offerLetterTemplateSettings: this.allData },
        overwrite,
      })
    },
    onSave() {
        this.onNavigationGuardianCheck({
          data: { offerLetterTemplateSettings: this.allData },
          overwrite: true,
        })
        this.fileSend = null
        this.edit = false
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    },
  },
}
</script>

<style lang="scss" scoped>
.send {
  width: 100%;
  display: grid;
  row-gap: 20px;
}
.customLineHeight {
  line-height: 16px !important;
  margin-bottom: 5px;
}
.btn-pt {
  height: 30px !important;
  padding: 0 !important;
  min-width: 30px !important;
}
</style>